export const getters = {
    getEtiqueta: state => state.etiqueta,
    getEtiquetas: state => state.etiquetas,
    getModalCadastroEtiqueta: state => state.modalCadastrarEtiqueta,
    getModalExcluirEtiqueta: state => state.modalExcluirEtiqueta,
    getModalImprimirEtiqueta: state => state.modalImprimirEtiqueta,
    // getModalPesquisarEtiqueta: state => state.modalPesquisarEtiqueta
}

export default {}